module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAGCAYAAAARx7TFAAAAfklEQVQImU3OvwqBcRyF8Q+vuAvruyi5Aau8+VMGJTemfmWxSK7BYjAarGw2k5SySF8Rz3jOc+qUUkoL1NHF3Y8a1niW0UIbS1Q/ToYVeshDGuKMPuaIbIYBLiFWcEKBLaZooIkrOjjGKjj8fQrhgRH2UX6lYIcJbhhj807xAtZ2GEByppT8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/w2.png
// module id = vt1m
// module chunks = 42